import { Component, Inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-data-view',
  imports: [CommonModule],
  templateUrl: './ekorg.list-view.html',
  styleUrls: ['./ekorg.list-view.scss'],
})
export class ekorgListView implements FieldOkItemComponent<any> {
  @Input() item: any;

  constructor() {}
}
